import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

// Polls only while the tab is visible and only re-renders when the payload actually changed.
export function usePoll(url, ms = 5000, deps = []) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const alive = useRef(true);
  const last = useRef("");
  const load = useCallback(async () => {
    try {
      const r = await api.get(url);
      const sig = JSON.stringify(r.data);
      if (alive.current && sig !== last.current) {
        last.current = sig;
        setData(r.data);
      }
      if (alive.current) setError(null);
    } catch (e) {
      if (alive.current) setError(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, ...deps]);
  useEffect(() => {
    alive.current = true;
    last.current = "";
    load();
    let id = null;
    const start = () => { if (ms && !id) id = setInterval(() => { if (!document.hidden) load(); }, ms); };
    const onVis = () => { if (!document.hidden) load(); };
    start();
    document.addEventListener("visibilitychange", onVis);
    return () => {
      alive.current = false;
      if (id) clearInterval(id);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [load, ms]);
  return { data, error, reload: load };
}
